// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3T3wm","rootCenter":"LoadMoreObserver_rootCenter__2SUqI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__W4PRm"};